import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as farmService from '@/services/farmService';
import { useAuth } from '@/contexts/AuthContext';

export const useCoordinatorFarms = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['coordinator-farms', user?.id],
    queryFn: () => farmService.getFarmsByCoordinator(user?.id!),
    enabled: !!user?.id
  });
};

export const useCoordinatorStats = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['coordinator-stats', user?.id],
    queryFn: () => farmService.getCoordinatorStats(user?.id!),
    enabled: !!user?.id
  });
};

export const useCreateFarmAsCoordinator = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  
  return useMutation({
    mutationFn: (farmData: any) => {
      const enrichedData = {
        ...farmData,
        coordinator_id: user?.id,
        registered_by: user?.id
      };
      return farmService.createFarm(enrichedData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['farms'] });
      queryClient.invalidateQueries({ queryKey: ['coordinator-farms'] });
      queryClient.invalidateQueries({ queryKey: ['coordinator-stats'] });
    }
  });
};